export default {
  state: {
    baseUrl:
      localStorage.getItem("dcgateway") &&
      JSON.parse(localStorage.getItem("dcgateway")).baseUrl
        ? JSON.parse(localStorage.getItem("dcgateway")).baseUrl
        : "",
    userInfo:
      localStorage.getItem("dcgateway") &&
      JSON.parse(localStorage.getItem("dcgateway")).userInfo
        ? JSON.parse(localStorage.getItem("dcgateway")).userInfo
        : "",
    dishInfo: localStorage.getItem("dcDishInfo")
      ? JSON.parse(localStorage.getItem("dcDishInfo"))
      : "",
    salesPoint: { descript: "所有", code: -1 },
    tableType: { descript: "所有", code: -1 },
    selectedPreOrder: {},
    tempTable: {
      color: "#FF5960",
      code: "9999",
      pccodeDescript: "临时桌",
      sta: 2,
      dishList: []
    },
    selectedTableInfo: {},
    shoppingCart: [],
    modifySDish: {},
    myOrderInfo: {},
    entryPreOrderUrl: '',
    masterInfo: {},
    entryMyOrderUrl: ''
  },
  getters: {},
  mutations: {
    submitUserInfo: (state, item) => {
      state.userInfo = item
    },
    submitDishInfo: (state, item) => {
      state.dishInfo = item
    },
    submitSalesPoint: (state, item) => {
      state.salesPoint = item;
    },
    submitTableType: (state, item) => {
      state.tableType = item;
    },
    submitSelectedPreOrder: (state, item) => {
      state.selectedPreOrder = item;
    },
    clearSelectedPreOrder: state => {
      state.selectedPreOrder = {};
    },
    sumbitSelectedTableInfo: (state, item) => {
      state.selectedTableInfo = item;
    },
    clearSelectedTableInfo: state => {
      state.selectedTableInfo = {};
    },
    sumbitShoppingCart: (state, item) => {
      state.shoppingCart = item;
    },
    clearShoppingCart: state => {
      state.shoppingCart = [];
    },
    submitTempTable: (state, arr) => {
      state.tempTable.dishList.push(...arr);
    },
    changeTempTable: (state, obj) => {
      if (obj.type == "change") {
        state.tempTable.dishList[obj.item.index] = obj.item;
      } else if (obj.type == "delete") {
        state.tempTable.dishList.splice(obj.item.index, 1);
      } else if (obj.type == "turnOut") {
        state.tempTable.dishList = obj.item;
      } else if (obj.type == "turnIn") {
        state.tempTable.dishList = obj.item;
      }
    },
    clearTempTable: state => {
      state.tempTable.dishList = [];
    },
    submitModifySDish: (state, item) => {
      state.modifySDish = item;
    },
    clearModifySDish: state => {
      state.modifySDish = {};
    },
    submiMyOrderInfo: (state, item) => {
      state.myOrderInfo = item;
    },
    clearMyOrderInfo: state => {
      state.myOrderInfo = {};
    },
    submiEntryPreOrderUrl: (state, url) => {
      state.entryPreOrderUrl = url;
    },
    clearEntryPreOrderUrl: state => {
      state.entryPreOrderUrl = "";
    },
    sumbitMasterInfo: (state, item) => {
      state.masterInfo = item;
    },
    clearMasterInfo: state => {
      state.masterInfo = {};
    },
    sumbitEntryMyOrderUrl: (state, url) => {
      state.entryMyOrderUrl = url;
    },
    clearEntryMyOrderUrl: state => {
      state.entryMyOrderUrl = "";
    },
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/mobileOrdering.js